import { render, staticRenderFns } from "./legal-information.vue?vue&type=template&id=79f3e950&scoped=true&"
import script from "./legal-information.vue?vue&type=script&lang=js&"
export * from "./legal-information.vue?vue&type=script&lang=js&"
import style0 from "./legal-information.vue?vue&type=style&index=0&id=79f3e950&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f3e950",
  null
  
)

export default component.exports